import { getChartColorsByPalette } from "../Charts.utils";

export const getBarChartColor = (colorMode: "light" | "dark"): string => {
  const defaultColors = getChartColorsByPalette(colorMode, "green");

  return defaultColors[0];
};
